/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CashInRequest} from '@cash-web/protos/squareup/cash/moneta/api/v1_0/CashIn.pb'
import {CashInResponse} from '@cash-web/protos/squareup/cash/moneta/api/v1_0/CashIn.pb'


export const addCash = (request: CashInRequest, options?: CashRequestOptions) => post<CashInRequest, CashInResponse>("/2.0/cash/add-cash", request, {...options, rejectOnError: true })